import { Link } from 'react-router-dom';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';

/**
 * Origin root placeholder. jp.lawsnote.com will grow a real landing page; for now
 * it just points at the tool that is going live first.
 */
export function HomePage() {
  return (
    <>
      <Header />
      <main className="mx-auto max-w-content px-5 py-16">
        <h1 className="text-[26px] font-bold tracking-tight text-ink">jp.lawsnote.com</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-ink-muted">公開中のツール</p>
        <ul className="mt-4 flex flex-col gap-2 text-[15px]">
          <li>
            <Link
              to="/formatting"
              className="text-brand underline underline-offset-2 hover:no-underline"
            >
              事件番号表記変換ツール
            </Link>
          </li>
        </ul>
      </main>
      <Footer />
    </>
  );
}
